import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getStoredAuth } from "@/lib/api";
import { DashboardShell } from "@/components/account/DashboardShell";

export const Route = createFileRoute("/dashboard")({
  head: () => ({
    meta: [{ title: "My Dashboard — OyoBooking" }, { name: "robots", content: "noindex, nofollow" }],
  }),
  component: DashboardLayout,
  beforeLoad: ({ location }) => {
    if (typeof window === "undefined") return;
    if (!getStoredAuth()) throw redirect({ to: "/login", search: { redirect: location.pathname } });
  },
});

function DashboardLayout() {
  return (
    <DashboardShell>
      <Outlet />
    </DashboardShell>
  );
}
